import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ResizeObserver polyfill for older browsers
if (!window.ResizeObserver) {
  window.ResizeObserver = class ResizeObserver {
    constructor(callback) {
      this.callback = callback;
      this.observations = [];
    }
    
    observe(element) {
      this.observations.push(element);
      // Simple fallback - trigger callback on window resize
      this.handleResize = () => {
        this.callback(this.observations.map(el => ({
          target: el,
          contentRect: el.getBoundingClientRect()
        })));
      };
      window.addEventListener('resize', this.handleResize);
    }
    
    unobserve(element) {
      const index = this.observations.indexOf(element);
      if (index > -1) {
        this.observations.splice(index, 1);
      }
      if (this.observations.length === 0) {
        window.removeEventListener('resize', this.handleResize);
      }
    }
    
    disconnect() {
      this.observations = [];
      window.removeEventListener('resize', this.handleResize);
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
